export const isObjectEmpty = (obj) => !obj || Object.entries(obj).length === 0;
